import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { get } from 'lodash'
import { Button } from 'components/misc'
import { modal } from 'redux/modules/app'
import { form } from 'helpers/decorators'
import { removeValidate } from 'models/contacts'
import { PERSON_STATES } from '../../../../constants/enums'


const enhance = compose(
  connect(null, { modal }),
  form({
    form: 'revoke-access-form',
    validate: removeValidate
  })
)

class RevokeAccess extends Component {
  static propTypes = {
    onRevokeAccess: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    modal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    reasonsList: [],
    selectContactFrom: []
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
      return
    }

    this.props.modal(null)
  }

  handleRevokeAccess = () => {
    const { match } = this.props

    const personId = get(match, 'params.assessorId')

    const orgId = get(match, 'params.organizationId')

    this.props.onRevokeAccess(personId, orgId)
  }

  render() {
    const {
      handleSubmit,
      submitting,
        data
    } = this.props

    const isActive = get(data, 'person.personState.value') === PERSON_STATES.active.id

    return (
      <form onSubmit={handleSubmit(() => this.handleRevokeAccess())} >
        <div className="row">
          <div className="col-xs-12">
            <h2 className="text--center">
              <FormattedMessage
                id="label.would_you_like_to_revoke"
                defaultMessage="Would you like to revoke access to this account?"
            />
            </h2>
          </div>

          <div className="col-xs-6">
            <Button type="button" onClick={this.handleClose} secondary>
              <FormattedMessage id="button.close" defaultMessage="Close" />
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              negative
              isLoading={submitting}
            >
              { isActive ? <FormattedMessage id="button.revoke" defaultMessage="Revoke" /> : <FormattedMessage id="button.unrevoke" defaultMessage="Unrevoke" /> }
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default enhance(RevokeAccess)
